import React, { useRef, useState } from "react";
import Button from "../../components/Button/index";
import { TypeForm } from "../../components/TypeForm/index";
import "./style.css";
import Logo from "../../components/Logo/Logo";
import {
  getAuth,
  createUserWithEmailAndPassword,
  sendEmailVerification,
} from "firebase/auth";
import ErrorMessageInForm from "../../components/ErrorMessageInForm";
import { IconInterfacesUser } from "../../components/IconInterfacesUser";
import phoneIcon from "../../img/static/phoneIcon.svg";
import emailIcon from "../../img/static/mailIcon.svg";
import passwordIcon from "../../img/static/passwordIcon.svg";
import Checkbox from "../../components/Checkbox/index.js";

import { useDispatch } from "react-redux";

import image from "../../assets/onboarding-image.jpg";

import {
  isCodiceFiscale,
  getStringLength,
  isEmail,
  isPhoneNumber,
} from "../../utils/utils";

import { useNavigate } from "react-router-dom";
import { PREFIXES } from "../../constants/phonePrefixes/prefixes";
import { isStepValid } from "../../utils/onboarding";
import { setIsLoading } from "../../store/slices/databaseTable";
import { provincieItaliaList } from "../../constants/provincie";
import Dropdown from "../../components/atoms/Dropdown/Dropdown";
import { NotifyTypes } from "../Notify/Notify";
import { app } from "../../lib/firebase/config";
import { saveSession } from "../../utils/auth/session";
import { client } from "../../lib/axios";
import { reportError } from "../../lib/errorReporting";
import AvantiIndietroStepButtons from "../../components/AvantiIndietroStepButtons";

const SignUpFamilyPage = () => {
  const [currentStep, setCurrentStep] = useState(0);

  const [formValues, setFormValues] = useState({
    name: "",
    surname: "",
    codiceFiscale: "",
    cellulare: "",
    email: "",
    confermaPassword: "",
    nuovaPassword: "",
    provincia: "",
  });

  const goToNextStep = () => {
    setCurrentStep(currentStep + 1);
  };

  const goToPreviousStep = () => {
    setCurrentStep(currentStep - 1);
  };

  const handleInputChange = (fieldName, value) => {
    setFormValues((prevFormValues) => ({
      ...prevFormValues,
      [fieldName]: value,
    }));
  };

  const renderStepContent = () => {
    switch (currentStep) {
      case 0:
        return (
          <Step0
            onNext={goToNextStep}
            formValues={formValues}
            onInputChange={handleInputChange}
          />
        );
      case 1:
        return (
          <Step1
            onNext={goToNextStep}
            formValues={formValues}
            onInputChange={handleInputChange}
          />
        );
      case 2:
        return (
          <Step2
            onNext={goToNextStep}
            onPrevious={goToPreviousStep}
            formValues={formValues}
            onInputChange={handleInputChange}
          />
        );
      case 3:
        return (
          <Step3
            onPrevious={goToPreviousStep}
            formValues={formValues}
            onInputChange={handleInputChange}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div>
      <div>{renderStepContent()}</div>
    </div>
  );
};

const Step0 = ({ onNext, formValues, onInputChange }) => {
  const handleClickNextButton = () => {
    onNext();
  };

  const handleInputChange = (fieldName, value) => {
    onInputChange(fieldName, value);
  };

  return (
    <div className="sign-up-interno">
      <div className="onboarding-interno">
        <Logo></Logo>
        <div className="onboarding-screen">
          <div className="typeforms-buttons grid-welcome">
            <div className="title-container">
              <h1 className="title">
                Il nostro portale ti mette in contatto con lavoratori affidabili
                e competenti, registrati subito per scoprirli!
              </h1>
            </div>
            <img src={image} alt="" />
            <h2 className="subtitle">
              Il portale è riservato solo agli associati Assindatcolf.
            </h2>
            <div className="div">
              <div className="selection-element-horrizonatal">
                <AvantiIndietroStepButtons
                  onNext={handleClickNextButton}
                  onPrevious={() => window.history.back()}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const Step1 = ({ onNext, formValues, onInputChange }) => {
  const { name, surname, codiceFiscale } = formValues;
  const [errorMessage, setErrorMessage] = useState("");

  const handleClickNextButton = () => {
    const trimmedName = name.trim();
    const trimmedSurname = surname.trim();
    const trimmedCodiceFiscale = codiceFiscale.trim().toUpperCase();
    const trimmedProvincia = formValues.provincia.trim();

    onInputChange("name", trimmedName);
    onInputChange("surname", trimmedSurname);
    onInputChange("codiceFiscale", trimmedCodiceFiscale);
    onInputChange("provincia", trimmedProvincia);

    if (!isCodiceFiscale(trimmedCodiceFiscale)) {
      setErrorMessage("Inserisci un codice fiscale valido");
    } else if (!trimmedProvincia) {
      setErrorMessage("Seleziona una provincia");
    } else if (!trimmedName) {
      setErrorMessage("Inserisci un nome");
    } else if (!trimmedSurname) {
      setErrorMessage("Inserisci un cognome");
    } else {
      setErrorMessage("");
      onNext();
    }
  };

  const handleInputChange = (fieldName, value) => {
    onInputChange(fieldName, value);
  };

  return (
    <div className="sign-up-interno">
      <Logo></Logo>
      <div className="sign-up-screen">
        <div className="typeforms-buttons">
          <div className="title-container">
            <h1 className="title">Crea il tuo profilo</h1>
          </div>
          <div class="div">
            <Dropdown
              className="dropdown-instance"
              options={provincieItaliaList}
              label="Dove stai cercando il lavoratore?*"
              onClick={(value) => handleInputChange("provincia", value)}
            />
            <TypeForm
              className="type-form-instance"
              label="Nome dell'associato"
              value={name}
              onChange={(value) => handleInputChange("name", value)}
            />
            <TypeForm
              className="type-form-instance"
              label="Cognome dell'associato"
              value={surname}
              onChange={(value) => handleInputChange("surname", value)}
            />
            <TypeForm
              className="type-form-instance"
              label="Codice Fiscale dell'associato"
              value={codiceFiscale}
              onChange={(value) =>
                handleInputChange("codiceFiscale", value.toUpperCase())
              }
            />
            <ErrorMessageInForm message={errorMessage} />
            <div className="buttons">
              <Button
                className={`button-instance ${
                  !isStepValid({
                    mandatoryFields: ["name", "surname", "codiceFiscale"],
                    formData: {
                      name,
                      surname,
                      codiceFiscale,
                    },
                  })
                    ? "button-disabled"
                    : ""
                }`}
                property1="primary"
                text="Avanti"
                onClick={handleClickNextButton}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const Step2 = ({ onNext, onPrevious, formValues, onInputChange }) => {
  const { email, cellulare } = formValues;
  const [errorMessage, setErrorMessage] = useState("");
  const [selectedPrefix, setSelectedPrefix] = useState(PREFIXES[0].prefix);

  const phoneNumber = cellulare.startsWith(selectedPrefix)
    ? cellulare.slice(selectedPrefix.length)
    : cellulare;

  const handleClickNextButton = () => {
    const trimmedEmail = email.trim().toLowerCase();
    const trimmedCellulare = cellulare.trim();

    onInputChange("email", trimmedEmail);
    onInputChange("cellulare", trimmedCellulare);

    if (isEmail(trimmedEmail)) {
      if (isPhoneNumber(trimmedCellulare)) {
        setErrorMessage("");
        onNext();
      } else {
        setErrorMessage("Inserisci un numero di telefono valido");
      }
    } else {
      setErrorMessage("Inserisci una mail valida");
    }
  };

  const handleClickPreviousButton = () => {
    onPrevious();
  };

  const handleInputChange = (fieldName, value) => {
    onInputChange(fieldName, value);
  };

  return (
    <div className="log-in-interno">
      <Logo></Logo>
      <div className="login-screen">
        <div className="typeforms-buttons">
          <div className="title-subtitle-container">
            <h1 className="title">Crea il tuo profilo</h1>
            <h3 className="subtitle-tel">
              Inserisci contatti di cui hai accesso, ti verrà inviato un codice
              di verifica al numero di telefono che inserirai
            </h3>
          </div>
          <div className="div">
            <TypeForm
              className="type-form-instance"
              label="Email"
              override={
                <IconInterfacesUser
                  className="icon-interfaces-user-instance"
                  combinedShape={emailIcon}
                />
              }
              value={email}
              onChange={(value) =>
                handleInputChange("email", value.toLowerCase())
              }
            />
            <TypeForm
              className="type-form-instance"
              label="Cellulare"
              type="tel"
              value={phoneNumber}
              prefix={
                <div className="wrapper-select-prefix">
                  <p>{selectedPrefix}</p>
                  <select
                    className="select-number-prefix"
                    onChange={(e) => {
                      const newPrefix = e.target.value.trim();
                      setSelectedPrefix(newPrefix);
                      handleInputChange(
                        "cellulare",
                        `${newPrefix}${phoneNumber}`
                      );
                    }}
                  >
                    {PREFIXES.map((prefix) => (
                      <option key={prefix.prefix} value={`${prefix.prefix} `}>
                        {prefix.prefix} {prefix.country}
                      </option>
                    ))}
                  </select>
                </div>
              }
              override={
                <IconInterfacesUser
                  className="icon-interfaces-user-instance"
                  combinedShape={phoneIcon}
                />
              }
              onChange={(value) => {
                const updatedValue = `${selectedPrefix}${value}`;
                handleInputChange("cellulare", updatedValue);
              }}
            />
            <ErrorMessageInForm message={errorMessage} />
          </div>
          <AvantiIndietroStepButtons
            onNext={handleClickNextButton}
            onPrevious={handleClickPreviousButton}
            nextDisabled={
              !isStepValid({
                mandatoryFields: ["email", "cellulare"],
                formData: {
                  email,
                  cellulare,
                },
              })
            }
          />
        </div>
      </div>
    </div>
  );
};

const Step3 = ({ onPrevious, formValues, onInputChange }) => {
  const { confermaPassword, nuovaPassword } = formValues;
  const [errorMessage, setErrorMessage] = useState("");
  const [isChecked, setIsChecked] = useState("unchecked");
  const isSubmitting = useRef(false);

  const navigate = useNavigate();

  const handleCheckboxChange = (isChecked) => {
    setIsChecked(isChecked ? "checked" : "unchecked");
  };

  const handleClickPreviousButton = () => {
    onPrevious();
  };

  const dr = useDispatch();

  const handleClickSignUpButton = async () => {
    if (isSubmitting.current) return;
    if (!validatePasswords()) return;
    if (isChecked !== "checked") {
      setErrorMessage("Accetta l'informativa di privacy");
      return;
    }

    isSubmitting.current = true;
    setErrorMessage("");
    dr(setIsLoading(true));

    const name = formValues.name.trim();
    const surname = formValues.surname.trim();
    const codiceFiscale = formValues.codiceFiscale.trim().toUpperCase();
    const cellulare = formValues.cellulare.trim();
    const email = formValues.email.trim().toLowerCase();
    const provincia = formValues.provincia.trim();

    onInputChange("name", name);
    onInputChange("surname", surname);
    onInputChange("codiceFiscale", codiceFiscale);
    onInputChange("cellulare", cellulare);
    onInputChange("email", email);
    onInputChange("provincia", provincia);

    try {
      const user = await createUser(email, nuovaPassword);

      await registerUser({
        uid: user.user.uid,
        name,
        surname,
        codiceFiscale,
        cellulare,
        email,
        provincia,
      });

      await sendVerificationEmail(user.user);

      // Session persistence is not required to complete registration. Do not
      // block the success screen on Firestore's browser transport; sign-in will
      // establish the session again if this best-effort write fails.
      void saveSession({ codiceFiscale }).catch(() => undefined);

      navigate(
        `/notify?type=${
          NotifyTypes.VERIFY_EMAIL
        }&m=${`Per completare la registrazione, controlla la tua casella di posta elettronica all'indirizzo ${email} e clicca sul link che ti abbiamo inviato.`}`
      );
    } catch (error) {
      handleError(error);
    } finally {
      isSubmitting.current = false;
      dr(setIsLoading(false));
    }
  };

  const validatePasswords = () => {
    if (nuovaPassword !== confermaPassword) {
      setErrorMessage("Inserisci le stesse password");
      return false;
    }
    if (getStringLength(nuovaPassword) < 6) {
      setErrorMessage("Inserisci una password più lunga di 6 caratteri");
      return false;
    }
    return true;
  };

  const createUser = async (email, password) => {
    try {
      return await createUserWithEmailAndPassword(
        getAuth(app),
        email,
        password
      );
    } catch (authError) {
      handleAuthError(authError);
      throw authError;
    }
  };

  const registerUser = async (userData) => {
    const res = await client.post("/auth/family/register", {
      ...userData,
      placement_user: true,
    });
    if (!res.data.success) {
      throw new Error(
        res.data?.message ||
          "Si è verificato un errore, riprova più tardi"
      );
    }
    return res;
  };

  const sendVerificationEmail = async (user) => {
    const url = getVerificationUrl();
    await sendEmailVerification(user, {
      url: `${url}/sign-up-family`,
      // url: `${url}/r/impl-2fa?cf=${encodeURIComponent(codiceFiscale)}`,
    });
  };

  const getVerificationUrl = () => {
    if (process.env.REACT_APP_PROJECT_ID === "assindatcolf-recruit-dwh-dev") {
      return "http://localhost:3000";
    }
    if (process.env.REACT_APP_PROJECT_ID === "assindatcolf-recruit-dwh-stage") {
      return "https://assindatcolf-recruit-dwh-stage.web.app";
    }
    return "https://cercalatuacolf.assindatcolf.it";
  };

  const handleAuthError = (error) => {
    console.log(error);
    if (error.code === "auth/email-already-in-use") {
      setErrorMessage("Questa email è già registrata");
    } else if (error.code === "auth/operation-not-allowed") {
      setErrorMessage("La registrazione con email/password non è abilitata");
    } else {
      setErrorMessage("Errore durante la registrazione: " + error.message);
    }
  };

  const handleError = (error) => {
    void reportError(error, { operation: "auth.family.registration" });
    console.error("Errore:", error);

    if (error.code?.startsWith("auth/")) return;

    const responseMessage = error.response?.data?.message;
    const safeMessage =
      typeof responseMessage === "string" && responseMessage.length <= 500
        ? responseMessage
        : "Si è verificato un errore, riprova più tardi";

    setErrorMessage(
      error.response?.status === 409
        ? safeMessage
        : "Errore durante la registrazione: " + safeMessage
    );
  };

  const handleInputChange = (fieldName, value) => {
    onInputChange(fieldName, value);
  };

  return (
    <div className="log-in-interno">
      <Logo></Logo>
      <div className="login-screen">
        <div className="typeforms-buttons">
          <div className="title-container">
            <h1 className="title">Crea il tuo profilo</h1>
          </div>
          <div className="div">
            <div className="div">
              <TypeForm
                className="type-form-instance"
                isPassword={true}
                label="Nuova Password"
                override={
                  <IconInterfacesUser
                    className="icon-interfaces-user-instance"
                    combinedShape={passwordIcon}
                  />
                }
                value={nuovaPassword}
                onChange={(value) => handleInputChange("nuovaPassword", value)}
              />
              <TypeForm
                className="type-form-instance"
                isPassword={true}
                label="Conferma Password"
                override={
                  <IconInterfacesUser
                    className="icon-interfaces-user-instance"
                    combinedShape={passwordIcon}
                  />
                }
                value={confermaPassword}
                onChange={(value) =>
                  handleInputChange("confermaPassword", value)
                }
              />
              <Checkbox
                isChecked={isChecked}
                onChange={handleCheckboxChange}
                page="/privacy-famiglia"
              ></Checkbox>
              <ErrorMessageInForm message={errorMessage} />

              <div id="captcha-container"></div>

              <div className="buttons">
                <Button
                  id="sign-up-button"
                  className={`button-instance ${
                    !isStepValid({
                      mandatoryFields: ["confermaPassword", "nuovaPassword"],
                      formData: {
                        confermaPassword,
                        nuovaPassword,
                      },
                    })
                      ? "button-disabled"
                      : ""
                  }`}
                  property1="primary"
                  text="Invia"
                  onClick={handleClickSignUpButton}
                />
                <Button
                  className="button-instance"
                  property1="secondary"
                  text="Indietro"
                  onClick={handleClickPreviousButton}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUpFamilyPage;
